export const OPEN_MSG = 'OPEN_MSG';
export const CLOSE_MSG = 'CLOSE_MSG';
